import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { useCareerAcceleratorsNavContent } from '../../../hooks/use-career-accelerator-nav-content';
import { MobileNavL1Nav, MobileNavSection, MobileNavSectionHeading } from '../mobile-nav.react-component';

/**
 * L1 (level-one) academies nav. Renders as a top-level drawer with "In-demand Careers" section.
 */
export const MobileAcademiesNav = observer(() => {
  const {
    gettext
  } = useI18n();
  const {
    renderAcademiesNavItemList
  } = useCareerAcceleratorsNavContent();
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-academies"
  }, /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, gettext('In-demand Careers')), /*#__PURE__*/React.createElement(MobileNavSection, null, renderAcademiesNavItemList('l1')));
});
//# sourceMappingURL=mobile-academies-nav.react-component.js.map